enum LocationViewMode {
  ADDRESS = "address",
  COORDINATES = "coordinates",
}

export default LocationViewMode;
